//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import upimg from './components/upimg.vue'
import upvideo from './components/upvideo.vue'
  export default {
    components: {
      upimg,
      upvideo,
    },
    created(){

    },
    methods:{
      trigger(){
        var stretchyNavs = document.getElementsByClassName("cd-stretchy-nav")[0];
        var time;
        if(stretchyNavs.className.indexOf("nav-is-visible")<0){
          stretchyNavs.className = "cd-stretchy-nav nav-is-visible"
          clearTimeout(time)
          document.getElementsByClassName("cd-stretchy-nav-ul")[0].style.display = "block"
        }else{
          stretchyNavs.className = "cd-stretchy-nav"
          time=setTimeout(function(){
            document.getElementsByClassName("cd-stretchy-nav-ul")[0].style.display = "none"
          },201)
        }
      }
    }
  }



// WEBPACK FOOTER //
// ./src/App.vue